import Vue from 'vue'
const state = {
  bounds: {
    box: [],
    geom: null,
    area: null
  },
  satfilter: {
    sn_year_s: 2013,
    sn_year_f: 2017,
    sat_type: 'Канопус-В',
    images: '{}',
    region: {}
  },
  filter: {
     fromGeom: false,
     subject: 0,
     forestry: 0,
     local_forestry: 0,
     sub_forestry: 0,
     kv: []
  },
  input: {
    subjects: [],
    forestries: [],
    local_forestries: [],
    sub_forestries: [],
    kvs: [],
  }
}

const mutations = {
  setFilter(state, {type, items}) {
    state['filter'][type] = items
  },
  setSatFilter(state, {type, items}) {
    state['satfilter'][type] = items
  }
}

const actions = {
  UpdateFilter ({ commit }) {
    Vue.http.get('php_scripts/v1/regionFilter.php', {params: state.filter}).then((res) => {
      state.input.subjects = res.data.subjects
      state.input.forestries = res.data.forestries
      state.input.local_forestries = res.data.local_forestries
      state.input.sub_forestries = res.data.sub_forestries
      state.input.kvs = res.data.kvs
      state.satfilter.images = res.data.images
      if(res.data.box != null) {
        state.bounds.geom = res.data.box.geom
        state.bounds.area = res.data.box.area
      }
      state.filter.fromGeom = false
    }).catch((err) => {
      console.log(err)
    })
  },
  UpdateFromGeom ({ commit }, polygon) {
    Vue.http.get('php_scripts/UpdateFromGeom.php', {params: {'polygon': polygon}}).then((res) => {
      //state.input.subjects = res.data.subjects
      //state.input.forestries = res.data.forestries
      //state.input.local_forestries = res.data.local_forestries
      //state.input.sub_forestries = res.data.sub_forestries
      //state.input.kvs = res.data.kvs
      //state.satfilter.images = res.data.images
      //state.input.subjects = [res.data.kvs.subject]
      /*state.filter.subject = res.data.kvs.subject.value
      state.input.forestries = [res.data.kvs.les_vo]
      state.filter.forestry = res.data.kvs.les_vo.value
      state.input.local_forestries = [res.data.kvs.u_lesvo]
      state.filter.local_forestry = res.data.kvs.u_lesvo.value
      state.input.sub_forestries = [res.data.kvs.podles_vo]
      state.filter.sub_forestry = res.data.kvs.podles_vo.value
      state.filter.kv = res.data.kvs.filter
      state.input.kvs = res.data.kvs.input*/
      if(res.data.box != null) {
        state.bounds.geom = res.data.box.geom
      }
    }).catch((err) => {
      console.log(err)
    })
  }
}

const getters = {
  
}

export default {
  state,
  mutations,
  actions,
  getters
}